import { render, staticRenderFns } from "./MedicalExaminationsForm.vue?vue&type=template&id=0527ebb1&"
import script from "./MedicalExaminationsForm.vue?vue&type=script&lang=js&"
export * from "./MedicalExaminationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports